<template>
	<transition name="scroll-y-reverse-transition" v-if="module">
		<v-row v-show="module" class="module" align="center">
			<v-carousel hide-delimiters :show-arrows="false">
				<v-carousel-item
					class="hover-hand"
					v-for="slide in [1]"
					:key="slide"
					:src="imageSrc($vuetify.breakpoint.xsOnly ? module.smallImage : module.image, $vuetify.breakpoint.xsOnly ? 'Biography' : 'Fixitno Banner')"
					reverse-transition="fade-transition"
					transition="fade-transition"
					v-on="module.link.length ? { click: () => goToUrl(module.link) } : {}"
				>
					<v-container fill-height grid-list-md text-xs-center :style="{ 'background-color': module.backgroundColor.color }">
						<v-row align-center>
							<v-col cols="12" class="d-flex" :class="module.alignContent">
								<div
									class="py-7 px-7 py-sm-10 px-sm-12 mx-6 mx-sm-12"
									style="max-width: 500px;"
									:style="{
										color: module.textColor.color,
										'text-align': !$vuetify.breakpoint.xsOnly ? module.textAlign : 'center',
										'background-color': module.contentBackgroundColor.color
									}"
								>
									<div v-if="module.title" class="">
										<h2 class="display-1 mb-3">
											{{ module.title }}
										</h2>
									</div>
									<div v-if="module.subTitle">
										<p>
											{{ module.subTitle }}
										</p>
									</div>
									<div v-if="!module.hideButton">
										<template v-for="link in module.link">
											<v-btn class="mt-7" :key="link.caption" :color="module.buttonColor.color" outlined :href="link.link" :target="link.openInNewWindow ? '_blank' : '_self'">{{
												link.caption
											}}</v-btn>
										</template>
									</div>
								</div>
							</v-col>
						</v-row>
					</v-container>
				</v-carousel-item>
			</v-carousel>
		</v-row>
	</transition>
</template>

<script>
export default {
	name: 'banner-module',
	props: ['module'],
	data() {
		return {
			imgIsLoaded: false
		};
	},
	methods: {
		linkUrl(linkArray) {
			if (!linkArray) {
				return '';
			}
			return linkArray[0].link;
		},
		imageSrc(image, crop) {
			if (!image.imageCrops) {
				return '';
			}
			const cropItem = image.imageCrops.find(ic => ic.alias == crop);
			return cropItem ? cropItem.cropUrl : '';
		},
		goToUrl(link) {
			if (link.length) {
				window.location.href = 'https://fixit.no' + link[0].link;
			}
		}
	},
	computed: {
		hasImage() {
			return !!Object(this.module).image;
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';

.module {
	margin-bottom: 100px;

	@media #{map-get($display-breakpoints, 'xs-only')} {
		margin-bottom: 50px;
	}

	.hover-hand{
		cursor: pointer;
	}

	&__text {
		h2 {
			font-size: 3rem;
			max-width: 20ch;
			line-height: 1.25;
		}

		p {
			max-width: 40ch;
		}
	}
}
</style>
